export default {
  Modal: "bbui-modal",
}
